import router from './routers'

router.beforeEach((to, from, next) => {
       if (to.meta.title) {
              document.title = '省拼达—' + to.meta.title
       }
       next();
})